module.exports = __webpack_public_path__ + "img/dir_open.bb8d0d8e.png";